module.exports = __webpack_public_path__ + "media/to-the-point.4654aff7.ogg";